module.exports = __webpack_public_path__ + "img/quadro.e63e15e5.jpg";